<template>
    <div class="stationNotice">
        <div class="station_right">
            <div class="station_right_in">
                <h2 class="station_right_h2">发票核验</h2>
                <ul class="station_main">
                    <li @click="jumpToDetail('/batchData')"><img src="@/assets/images/import-icon.png" alt="">
                        <p>批次修改</p>
                    </li>
                    <li @click="jumpToDetail('/invoiceChange')"><img src="@/assets/images/change-icon.png" alt="">
                        <p>发票修改</p>
                    </li>
                    <li @click="jumpToDetail('/risk')"><img src="@/assets/images/risk-icon.png" alt="">
                        <p>风险生成</p>
                    </li>
                    <li @click="showConfirm"><img src="@/assets/images/pushRisk-icon.png" alt="">
                        <p>推送风险</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'invoiceCheck',
    data() {
        return {

        }
    },
    methods: {
        jumpToDetail(data) {
            this.$router.push(data)
        },
        showConfirm() {
            let that = this
            this.$confirm({
                title: '提示',
                content: '确定要推送风险吗？',
                okText: '确定',
                cancelText: '取消',
                onOk() {
                    that.http.get(`/ystOpenPlatformBff/tool/risk/push`, res => {
                        if(res.success) {
                            that.$message.success('操作成功！')
                        }
                    })
                },
                onCancel() { },
            });
        },
    }
}
</script>

<style lang="scss">
ul.station_main {
    padding-top: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    border-top: 1px solid #f1f1f1;

    li {
        position: relative;
        top: 0px;
        width: 44%;
        margin: 15px 3%;
        background-color: #f7f7f7;
        border: 1px solid #eee;
        cursor: pointer;
        text-align: center;
        padding: 15px 0px;
        transition: all .5s;
        border-radius: 10px;

        p {
            margin-top: 5px;
            transition: all .5s;
        }

        &:hover {
            border: 1px solid #2d8cf0;
            background-color: rgba(45, 140, 240, .1);
            // top: -5px;

            img {
                transform: scale(1.1);
            }

            p {
                color: #2d8cf0;
            }
        }

        img {
            width: 100px;
            height: 100px;
            opacity: .7;
            transition: all .5s;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/_developCenter/InvoiceCheck.vue